
window.onWizzyScriptLoaded = function() {

  $("body").on("click", ".wizzy-mobile-facets-show-results", function(e) {
    $(".wizzy-filters-bg").click()
  });
  
  $('body').on("click", function(event) {
    let x = document.querySelector(".wizzy-search-filters-list-top .wizzy-facet-head.facet-head-product_delivery_time_product.active");

    let ele = event.target;
    while(ele !== document.body) {
      if(ele.classList.contains("facet-block-product_delivery_time_product")) {
        return;
      }
      ele = ele.parentNode;
    }

    if(x) {
      x.classList.remove("active");  
    }
  });
  

  var isEventsAttached = false;
  const wizzyCustomUtils={
      afterFilterItemGotClickedFlag: false,
      caratWeightOrder: [
        "0.01 - 0.50",
        "0.51 - 1.00",
        "1.01 - 1.50",
        "1.51 - 3.00",
        "3.01 - 4.00",
        "4.01 - 5.00",
        "Over 5.01",
        "Undefined",
      ],
      textualBadges: {
        "Free Gift | 1 Offer": true,
        "Free Gifts | 2 Offers": true,
        "Free Gifts | 3 Offers": true,
        "2 Free Gifts | 1 Offer": true,
        "2 Free Gifts | 2 Offers": true,
        "2 Free Gifts | 3 Offers": true,
        "3 Free Gifts | 1 Offer": true,
        "3 Free Gifts | 2 Offers": true,
        "3 Free Gifts | 3 Offers": true,
        "Free Gift": true,
        "2 Free Gifts": true,
        "3 Free Gifts": true,
        "1 Offer": true,
        "2 Offers": true,
        "3 Offers": true
      },
      swatchFromCollectionHandle: {
        "princess-cut-rings": "Princess",
        "cushion-cut-rings": "Cushion",
        "round-rings": "Round",
        "oval-rings": "Oval",
        "heart-shape-rings": "Heart",
        "marquise-cut-rings": "Marquise",
        "pear-shape-rings": "Pear",

        "princess-cut-necklaces": "Princess",
        "cushion-cut-necklaces": "Cushion",
        "heart-shape-necklaces": "Heart",
        "round-necklaces": "Round",
        "marquise-cut-necklaces": "Marquise",
        "oval-necklaces": "Oval",
        "pear-shape-necklaces": "Pear",

        "princess-cut-earrings": "Princess",
        "cushion-cut-earrings": "Cushion",
        "heart-shape-earrings": "Heart",
        "round-earrings": "Round",
        "marquise-cut-earrings": "Marquise",
        "oval-earrings": "Oval",
        "pear-shape-earrings": "Pear",

        "princess-cut-engagement-rings": "Princess",
        "cushion-cut-engagement-rings": "Cushion",
        "heart-shape-engagement-rings": "Heart",
        "round-engagement-rings": "Round",
        "marquise-cut-engagement-rings": "Marquise",
        "oval-cut-engagement-rings": "Oval",
        "pear-shape-engagement-rings": "Pear",

        "princess-shape-wedding-rings": "Princess",
        "cushion-cut-wedding-rings": "Cushion",
        "heart-shape-wedding-rings": "Heart",
        "round-wedding-rings": "Round",
        "marquise-cut-wedding-rings": "Marquise",

        "vintage-style-rings": "Vintage Inspired",
        "stackables-rings": "stack",
        "fashion-rings": "fashion",
        "side-stone-rings": "side stone",
        "solitaire-rings": "solitaire",
        "halo-rings": "Halo",
        "hidden-halo-rings": "hidden halo",
        "three-stone-rings": "Three Stone",
        "heart-rings": "heart",
        "classic-rings": "Classic",

        "solitaire-necklaces": "solitaire",
        "three-stone-necklaces": "three stone",
        "cross-necklaces": "cross",
        "hearts-shape-necklaces": "Hearts",
        "halo-necklaces": "Halo",
        "tennis-necklaces": "Tennis",
        "fashion-necklaces": "fashion",
        "hidden-halo-necklaces": "hidden halo",
        "halo-earrings": "halo",
        "hidden-halo-earrings": "hidden halo",
        "studs-earrings": "studs",
        "statement-fashion-earrings": "high statement",
        "fashion-earrings": "fashion",
        "dangle-and-drop-earrings": "dangle drop",
        "hoop-earrings": "Hoops",
        "tennis-bracelets": "Tennis",
        "bridal-sets-engagement-rings": "bridal sets",
        "classic-engagement-rings": "Classic",
        "anniversary-rings": "anniversary",
        "eternity-wedding-rings": "eternity",
        "stack-wedding-rings": "stack",
        
      },
      swatchesMap: {

        "side stone": "product_style_tags",
        "Vintage Inspired": "product_style_tags",
        "stack": "product_style_tags",
        "fashion": "product_style_tags",
        "solitaire": "product_style_tags",
        "Halo": "product_style_tags",
        "hidden halo": "product_style_tags",
        "Three Stone": "product_style_tags",
        "three stone": "product_style_tags",
        "heart": "product_style_tags",
        "Classic": "product_style_tags",
        "cross": "product_style_tags",
        "Hearts": "product_style_tags",
        "Tennis": "product_style_tags",
        "halo": "product_style_tags",
        "studs": "product_style_tags",
        "high statement": "product_style_tags",
        "dangle drop": "product_style_tags",
        "Hoops": "product_style_tags",
        "bridal sets": "product_style_tags",
        "anniversary": "product_style_tags",
        "eternity": "product_style_tags",
        
        
        "1": "product_Carat",
        "2": "product_Carat",
        "3": "product_Carat",
        "5": "product_Carat",
        "10": "product_Carat",

        "Diamond":"product_gemstone_variant",
        "Sapphire":"product_Gemstone",
        "Emerald":"product_Gemstone",
        "Opal":"product_Gemstone",
        "Aquamarine":"product_Gemstone",
        "Ruby":"product_Gemstone",
        "Amethyst":"product_Gemstone",
        "Garnet":"product_Gemstone",
        "Morganite":"product_Gemstone",
        "Swiss Blue Topaz":"product_Gemstone",
        "Peridot":"product_Gemstone",
        "Tanzanite":"product_Gemstone",
        "Pink Tourmaline":"product_Gemstone",
        "Blue Topaz":"product_Gemstone",
        "Citrine":"product_Gemstone",

        "14K Rose Gold":"product_Metal",
        "14K Yellow Gold":"product_Metal",
        "14K White Gold":"product_Metal",
        "18K Rose Gold":"product_Metal",
        "18K Yellow Gold":"product_Metal",
        "18K White Gold":"product_Metal",
        "Silver":"product_Metal",
        "Platinum":"product_Metal",
        "14K Rose Gold/White Gold":"product_Metal",
        "14K Yellow Gold/White Gold":"product_Metal",
        "14K White Gold/Rose Gold":"product_Metal",
        "18K White Gold/Rose Gold":"product_Metal",
        "18K Yellow Gold/White Gold":"product_Metal",
        "14K Rose Gold/White Gold":"product_Metal",
        "18K Rose Gold/White Gold":"product_Metal",

        "Cushion":"product_gemstone_shape_variant",
        "Oval":"product_gemstone_shape_variant",
        "Pear":"product_gemstone_shape_variant",
        "Princess":"product_gemstone_shape_variant",
        "Round":"product_gemstone_shape_variant",
        "Marquise":"product_gemstone_shape_variant",
        "Heart":"product_gemstone_shape_variant"
        
      },
      customTemplates:[
          'wizzy-search-results-product',
          'wizzy-search-results',
          'wizzy-search-wrapper',
          'wizzy-autocomplete-wrapper',
          'wizzy-autocomplete-topproducts',
          'wizzy-selected-facets-block',
          'wizzy-search-empty-results',
          'wizzy-facet-item-common',
          'wizzy-selected-facet-item-common',
          'wizzy-collection-empty-results'
      ],
      maxMobileScreenWidth:768,
      isWizzyMobile(){
        return window.matchMedia(`(max-width: ${this.maxMobileScreenWidth}px)`).matches;
      },
      registerWizzyEvent:function( eventName,callback ){
        window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents[eventName], function(payload=null) {
          return callback(payload);
        })
      },
      changeWizzyTemplate:function (name){
        let newDiv = document.getElementById(name+"-new").text;
        let oldDiv = document.getElementById(name)
        oldDiv.text = newDiv;
      },
      replaceAllCustomTemplates:function(){
        for(let i in this.customTemplates){
          this.changeWizzyTemplate(this.customTemplates[i]);
        }
      },
      isWizzyMobile:function(){
        return window.screen.width < 768;
      },
      whenScriptLoaded:function(){
        $('input[name="q"]').attr('autocomplete','off');
        $('form[action="/search"]').attr('action','/pages/search');
        $('form[action="/pages/search"] input').attr('autocomplete','off');
        this.replaceAllCustomTemplates();
        this.attachClickEvents();
        
      },
      attachClickEvents(){
  
        $('body').on('click','.wizzy-search-results-rendered .currency-converter-chooser-item',()=>{
          window.location.reload();
        })
        $('body').on('click','.wizzy-facet-head',function (e) {
          let targetEle= $(e.target)
          let parentEle=targetEle.parents('.wizzy-filters-facet-block');
          let position = parentEle.position();
          let left = position.left - parentEle.width();
          left= e.clientX;
          left=parentEle.position().left - (parentEle.width() + 50)  ; 
          if (left<0) {
            left=0
          }
          
          let leftValue= `${left}px`
          $('.wizzy-facet-list').css('left',leftValue)
        });
  
        $('body').on('click', '#menu-drawer .field', function(){
          $(".header__icon--menu").click();
          $(".wizzy-search-input").focus();
          $(".wizzy-search-input").click();
        })
      },
  
      setOffset(payload,desktop=1000,mobile=1200){
        if (!payload.search.configs.pagination.infiniteScrollOffset || (payload.search.configs.pagination.infiniteScrollOffset && typeof payload.search.configs.pagination.infiniteScrollOffset != 'object')) {
          payload.search.configs.pagination.infiniteScrollOffset={};  
        }
        payload.search.configs.pagination.infiniteScrollOffset.desktop=desktop;
        payload.search.configs.pagination.infiniteScrollOffset.mobile=mobile;
      },
    
      beforeInit:function(){
        let self=this;
          this.registerWizzyEvent('BEFORE_INIT',(payload)=>{
            if(payload.endpoints) {
                payload.endpoints.common="https://uranus-api.wizsearch.in";  
            }else {
                payload.endpoints = { "common": "https://uranus-api.wizsearch.in" }
            }
              return payload;
          });
          this.registerWizzyEvent('BEFORE_LAZY_INIT',(payload)=>{

            if(document.documentElement.clientWidth > 768) {
              payload.common.lazyDOMConfig.searchInputIdentifiers = [{
                "dom": "#desktop_search",
                "type": "search"
              }];  
            }else {
              payload.common.lazyDOMConfig.searchInputIdentifiers = [{
                "dom": "#Search-In-Modal",
                "type": "search"
              }];
            }

            if(payload.endpoints) {
                payload.endpoints.common="https://uranus-api.wizsearch.in";  
            }else {
                payload.endpoints = { "common": "https://uranus-api.wizsearch.in" }
            }
            
            payload.search.configs.facets.leftFacets.mobileCollapsible = true;
            // window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible = true;
            self.setOffset(payload,1500,2500);
            self.setCurrentCurrenacy(payload);
            payload.search.configs.general.minQueryLength = 1; 

            payload.filters.configs.keepOpenedInMobileAfterApply = true;
            window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;

            payload.search.configs.facets.leftFacets.firstLeftDefaultOpened = false;
            window.wizzyConfig.search.configs.facets.leftFacets.firstLeftDefaultOpened = false;
            
            window.wizzyConfig.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";

            window.wizzyConfig.search.configs.facets.configs.push({
                label: "Price",
                buckets: [{
                    from: 0,
                    to: 1000
                }, {
                    from: 1000,
                    to: 2000
                }, {
                    from: 2000,
                    to: 3000
                }, {
                    from: 3000,
                    to: 4000
                }, {
                    from: 4000,
                    to: 5000
                }, {
                    from: 5000
                }],
                key: "sellingPrice",
                position: "left",
                order: 6
            });
            

            return payload;
          });
      },
      setCurrentCurrenacy(config){
        let currencyFromLocaStorage  = window.localStorage.getItem('cbb-currency-converter-currency');
        if (currencyFromLocaStorage && currencyFromLocaStorage.length>1) {
          currencyFromLocaStorage=JSON.parse(currencyFromLocaStorage);
          config.store.currency.code=currencyFromLocaStorage.value;
  
          switch(currencyFromLocaStorage.value){
              case'EUR':
                config.store.currency.symbol="€";
              break;
  
              case'JPY':
                config.store.currency.symbol="¥";
              break;
              
              case'GBP':
                config.store.currency.symbol="£";
              break;
          }
          
        }else{
          config.store.currency.code="USD";
           config.store.currency.symbol="$";
        }
      },
      enabledSwatch(){
                  wizzyGemSlider();
                  wizzyUpdateVariantImages();
      },
      viewRendered:function(){
          let self = this;
            this.registerWizzyEvent('VIEW_RENDERED',(payload)=>{

            const targetList = document.querySelector('.wizzy-search-results-list.grid');
            if(!targetList.querySelector(`.grid__item[class*="size--"]`) && window.collectionBanners) {
              targetList.insertAdjacentHTML('beforeend', window.collectionBanners);
            }
              
            let wizzySelectedFilters = document.querySelector(".wizzy-selected-filters");
            if(wizzySelectedFilters && window.wizzyConfig.common.isOnCategoryPage && window.location.search.length < 10) {
              wizzySelectedFilters.style.display = "none";
            }else if(wizzySelectedFilters) {
              wizzySelectedFilters.style.display = "block";
            }
              
              if(payload.data.api=='search' || payload.data.api=='filter' ||payload.data.api== "variation"){
                   self.enabledSwatch();
              }
  
              (function () {
      // Add a flag to ensure the code runs only once
    
  
      function iWishLoadScript(e, t) {
          for (var a = 0; a < e.length; a++) {
              var n = document.createElement("script");
              n.type = "text/javascript", n.async = !0, n.src = e[a], document.getElementsByTagName("head")[0].appendChild(n), 0 == a && (n.readyState ? n.onreadystatechange = function () {
                  "loaded" !== n.readyState && "complete" !== n.readyState || (n.onreadystatechange = null, t())
              } : n.onload = function () {
                  t()
              })
          }
      }
  
      function asyncLoadshopapps() {
          if (isEventsAttached) {
              return; // If events are already attached, return early
          }
  
          var iWishUrls = ["https://cdn.myshopapps.com/iwish/iwishlist_v2.js"];
          iWishLoadScript(iWishUrls, function () {
  
              // Use event delegation on the body
              jQuery("body").on("click", "a[href='/apps/iwish']", function (e) {
                  if (typeof (Storage) !== "undefined") {
                      e.preventDefault();
                      iWishPost('/apps/iwish', { iwishlist: JSON.stringify(iWishlistmain), cId: iwish_cid });
                  }
              });
  
              jQuery("body").on("click", ".iWishAdd", function () {
                  var iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
                  iwish_add(jQuery(this), iWishvId);
                  iWishCounter();
                  return false;
              });
  
              jQuery("body").on("click", ".iWishAddColl", function () {
                  var iWishvId = jQuery(this).attr("data-variant");
                  iwish_addCollection(jQuery(this), iWishvId);
                  iWishCounter();
                  if (jQuery('.iWishAddColl[data-variant=' + iWishvId + ']').length > 1) {
                      jQuery('.iWishAddColl[data-variant=' + iWishvId + ']').addClass('iwishcheck');
                      iwishCheckColl();
                  }
                  return false;
              });
  
              isEventsAttached = true; // Set the flag to true after attaching events
          });
  
          setTimeout(function () {
              iWishCounter();
          }, 2000);
      }
  
                function applyIWishClasses(iWishlistmain) {
      for (var key in iWishlistmain) {
          if (iWishlistmain.hasOwnProperty(key)) {
              var productId = key;
              var variantIds = iWishlistmain[key];
  
              // Check for elements with data-product attribute equal to the current key
              var elements = document.querySelectorAll('[data-product="' + productId + '"]');
  
              elements.forEach(function (element) {
                  // Add class iwishAdded to the element
                  element.classList.add('iwishAdded');
  
                  // // Check for child svg elements and set their fill to #000000
                  // var svgChildren = element.querySelectorAll('svg');
                  // svgChildren.forEach(function (svg) {
                  //     svg.style.fill = '#000000';
                  // });
              });
          }
      }
  }
  
  // // Example usage with your provided object
  // var iWishlistmain = {
  //     "8500977893683": ["46147988488499"],
  //     "8500995785011": ["46148179231027"],
  //     "8501130199347": ["46149818908979"],
  //     "8501065089331": ["46148985913651"]
  // };
  
  applyIWishClasses(iWishlistmain);
  
      asyncLoadshopapps();
  })();
  
              return payload;
            });
        },
      afterTransform:function(){
        let self = this;
          self.registerWizzyEvent('AFTER_PRODUCTS_TRANSFORMED',(productList)=>{

              let hashIds = [];
              productList = productList.filter(function(item) {
                if(typeof item.groupId !== 'undefined' && item.groupId !== "") {
                  if(typeof hashIds[item.groupId] !== 'undefined') {
                    return false;
                  }else {
                    hashIds[item.groupId] = true;
                    return true;
                  }
                }else if(typeof hashIds[item.id] !== 'undefined') {
                  return false;
                }else {
                  hashIds[item.id] = true;
                  return true;
                }
              });
            
              productList=productList.map((x)=>{
  
                x.subTitle = x.subTitle.toLowerCase();
                
                if(x.sellingPrice) {
                  let dotIndex1 = x.sellingPrice.indexOf('.');
                  x.sellingPrice = dotIndex1 === -1 ? x.sellingPrice : x.sellingPrice.substring(0, dotIndex1);
                }
  
                if(x.price) {
                  let dotIndex2 = x.price.indexOf('.');
                  x.price = dotIndex2 === -1 ? x.price : x.price.substring(0, dotIndex2);
                }
                
                x=self.makeMetalSwatch(x);
                x=self.makeGemstoneSwatch(x);
                x=self.makeShapeSwatch(x);
                x=self.makeCaretSwatch(x);
                x=self.attachMinPrice(x);
  
  
                if(x.swatches) {
                  let totalSwatches = x.swatches.length;
                  let m = 0;
                  for(let i = 0; i < totalSwatches; i++) {
                    m = x.swatches[i].values.length;
                    for(let j = 0; j < m; j++) {
                      
                    }
                  }
                }
        
    
                
                x.symbol=wizzyConfig.store.currency.symbol;
                x.title = x.name;


                try {
                  let carats = null;
                  let typeDiamond = false;
                  let qualityType = null;
                  let productType = null;
                  let gemstoneCount = null;
                  let textualBadge = null;
                  let showAmazing = null;
  
                  let attributeLen = x.attributes.length;
                  for(let i = 0; i < attributeLen; i++) {
                  
                    if(x.attributes[i].id === "product_tags") {
                      let temp = x.attributes[i].values[0].value[0];
                      if(temp.includes("Trending")) {
                        showAmazing = true;
                      }
                    }else if(x.attributes[i].id === "product_variant_price_custom") {
                      x.newSellingPrice = x.attributes[i].values[0].value[0];
                    }else if(x.attributes[i].id === "product_product_type") {
                      let temp = x.attributes[i].values[0].value[0].toLowerCase();
                      productType = x.attributes[i].values[0].value[0];
                      
                      if(temp.includes("rings") && temp.indexOf("earring") === -1) {
                        x.customAddToCart = true;
                      }
                    } else if(x.attributes[i].id === "product_gemstone_count_variant") {
                      gemstoneCount = parseFloat(x.attributes[i].values[0].value[0]);
                    } else if(x.attributes[i].id === "product_gemstone_carat_variant") {
                      carats = parseFloat(x.attributes[i].values[0].value[0]);
                    }else if(x.attributes[i].id === "product_gemstone_variant") {
                      let temp = x.attributes[i].values[0].value[0].toLowerCase();
                      if(temp === "diamond") {
                        typeDiamond = true;
                      }
                    }else if(x.attributes[i].id === "product_gemstone_quality_grade_variant") {
                      qualityType = x.attributes[i].values[0].value[0];
                    }else if(x.attributes[i].id === "product_badges_variant") {
                      textualBadge = x.attributes[i].values[0].value[0];
                    }else if(x.attributes[i].id === "product_collection_message_custom") {
                      let temp = x.attributes[i].values[0].value[0];
                      x.collectionMessage = temp;
                    }else if(x.attributes[i].id === "product_Badge_tags") {
                      let temp = x.attributes[i].values[0].value[0];
                      const arrBadge = temp.split("|");

                      console.log(x, arrBadge);
                      if(arrBadge.length > 1) {
                        let firstText = arrBadge[0].includes("Free") ? '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.88143 1.30601C3.72114 1.30601 3.56366 1.3482 3.42484 1.42835C3.28602 1.5085 3.17075 1.62377 3.0906 1.76259C3.01045 1.90141 2.96826 2.05889 2.96826 2.21918C2.96826 2.37948 3.01045 2.53695 3.0906 2.67577C3.17075 2.81459 3.28602 2.92987 3.42484 3.01002C3.56366 3.09016 3.72114 3.13236 3.88143 3.13236V3.13523H5.46777L4.67452 1.76129L4.67226 1.76259C4.59212 1.62377 4.47684 1.5085 4.33802 1.42835C4.1992 1.3482 4.04173 1.30601 3.88143 1.30601ZM2.53635 2.99577C2.60819 3.1202 2.69663 3.23351 2.79877 3.33281H1.20032C0.905771 3.33281 0.666993 3.57159 0.666993 3.86614V5.99944C0.666993 6.29399 0.905771 6.53276 1.20032 6.53276H1.73368V6.53294V10.7995C1.73368 11.0941 1.97246 11.3329 2.267 11.3329H9.73356C10.0281 11.3329 10.2669 11.0941 10.2669 10.7995V6.53294V6.53276H10.8002C11.0947 6.53276 11.3335 6.29399 11.3335 5.99944V3.86614C11.3335 3.57159 11.0947 3.33281 10.8002 3.33281H9.22355C9.3257 3.23351 9.41413 3.1202 9.48597 2.99577C9.62229 2.75965 9.69406 2.49182 9.69406 2.21918C9.69406 1.94655 9.62229 1.67871 9.48597 1.4426C9.34965 1.20649 9.15359 1.01042 8.91748 0.874101C8.68136 0.737782 8.41353 0.666016 8.14089 0.666016C7.86825 0.666016 7.60042 0.737782 7.36431 0.8741C7.14212 1.00238 6.95539 1.18357 6.82054 1.40125C6.81104 1.4133 6.80228 1.42617 6.79438 1.43985L6.01116 2.79643L5.22794 1.43985C5.22004 1.42617 5.21128 1.41329 5.20178 1.40125C5.06693 1.18357 4.8802 1.00238 4.65801 0.8741C4.4219 0.737782 4.15407 0.666016 3.88143 0.666016C3.60879 0.666016 3.34096 0.737782 3.10485 0.874101C2.86874 1.01042 2.67267 1.20649 2.53635 1.4426C2.40003 1.67871 2.32827 1.94655 2.32827 2.21918C2.32827 2.49182 2.40003 2.75965 2.53635 2.99577ZM7.3478 1.76129L7.35006 1.76259C7.43021 1.62377 7.54548 1.5085 7.6843 1.42835C7.82312 1.3482 7.9806 1.30601 8.14089 1.30601C8.30119 1.30601 8.45866 1.3482 8.59748 1.42835C8.7363 1.5085 8.85158 1.62377 8.93173 1.76259C9.01187 1.90141 9.05407 2.05889 9.05407 2.21918C9.05407 2.37948 9.01187 2.53695 8.93173 2.67577C8.85158 2.81459 8.7363 2.92987 8.59748 3.01002C8.45866 3.09016 8.30119 3.13236 8.14089 3.13236V3.13523H6.55455L7.3478 1.76129ZM1.30698 3.9728V5.89277H5.70187V3.9728H1.30698ZM6.34276 3.9728V5.89277H10.6935V3.9728H6.34276ZM6.34276 6.6396H9.62689V10.6929H6.34276V6.6396ZM5.70187 10.6929H2.37367V6.6396H5.70187V10.6929Z" fill="#70450A"/> </svg>' + arrBadge[0] + '<span class="wizzy-badge-point-breaker"></span>' : '<svg data-v-67befcd3="" data-v-be3184e6="" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-67befcd3="" fill-rule="evenodd" clip-rule="evenodd" d="M10.8922 16.7125C10.4039 17.2034 9.61223 17.2092 9.12056 16.7292L9.11222 16.72C9.1105 16.7182 9.10882 16.7164 9.1072 16.7146C9.10607 16.7134 9.10496 16.7121 9.10389 16.7109L8.50306 16.1117C8.03056 15.6409 7.40306 15.3817 6.73473 15.3809H5.87889C5.18389 15.3809 4.61973 14.8159 4.61973 14.1217V13.2625C4.61973 12.595 4.36056 11.9675 3.88889 11.4942L3.28723 10.8925C2.79473 10.4034 2.79223 9.60419 3.28139 9.11169L3.28723 9.10605C3.29112 9.10234 3.295 9.09864 3.29889 9.09419L3.89056 8.50169C4.36056 8.02836 4.61973 7.40086 4.61973 6.73336V5.87919C4.61973 5.18503 5.18473 4.62003 5.87889 4.61919H6.73639C7.40139 4.61919 8.02889 4.36086 8.50723 3.88836L9.10639 3.28753C9.59556 2.79503 10.3947 2.79253 10.8956 3.28836L11.4972 3.89086C11.9697 4.36003 12.5972 4.61919 13.2647 4.61919H14.1214C14.8164 4.61919 15.3814 5.18419 15.3814 5.87919V6.73503C15.3814 7.40253 15.6397 8.02919 16.1122 8.50503L16.7131 9.10669C16.9522 9.34503 17.0847 9.66086 17.0856 9.99669C17.0864 10.3334 16.9556 10.6509 16.7114 10.8959L16.1114 11.4967C15.6397 11.9692 15.3814 12.5967 15.3814 13.2642V14.1217C15.3814 14.8159 14.8164 15.3809 14.1214 15.3809H13.2631C12.6056 15.3809 11.9606 15.6467 11.4939 16.1125L10.8922 16.7125ZM8.23176 17.6077C8.72093 18.0927 9.36009 18.3343 9.99926 18.3343C10.6443 18.3343 11.2893 18.0877 11.7784 17.5952L12.3768 16.9968C12.6109 16.7643 12.9334 16.631 13.2634 16.631H14.1226C15.5059 16.631 16.6318 15.5052 16.6318 14.1218V13.2643C16.6318 12.9293 16.7618 12.6152 16.9959 12.3793L17.6068 11.7702C18.0793 11.2943 18.3384 10.6635 18.3359 9.99266C18.3334 9.32183 18.0701 8.69266 17.5959 8.22183L16.9976 7.62266C16.7618 7.38516 16.6318 7.06933 16.6318 6.73516V5.87933C16.6318 4.49516 15.5059 3.36933 14.1218 3.36933H13.2651C12.9301 3.36933 12.6151 3.23933 12.3793 3.00516L11.7701 2.39599C10.7876 1.41933 9.19509 1.42433 8.22093 2.40516L7.62509 3.00266C7.38593 3.23849 7.07093 3.36933 6.73676 3.36933H5.87843C4.49509 3.37016 3.37009 4.49599 3.37009 5.87933V6.73349C3.37009 7.06766 3.23926 7.38349 3.00509 7.61933L2.39843 8.22766L2.37593 8.25016C1.42009 9.23349 1.43176 10.8102 2.40509 11.7785L3.00426 12.3768C3.23926 12.6135 3.37009 12.9277 3.37009 13.2627V14.1218C3.37009 15.5052 4.49509 16.631 5.87926 16.631H6.73426C7.06926 16.6318 7.38426 16.7618 7.62009 16.996L8.21176 17.5868C8.21843 17.5943 8.22509 17.601 8.23176 17.6077ZM7.41734 12.5843C7.539 12.7068 7.699 12.7677 7.859 12.7677C8.019 12.7677 8.179 12.7068 8.30067 12.5843L12.5848 8.30102C12.829 8.05685 12.829 7.66102 12.5848 7.41685C12.3407 7.17268 11.9448 7.17268 11.7007 7.41685L7.41734 11.701C7.17317 11.9452 7.17317 12.3402 7.41734 12.5843ZM12.0862 12.9157C11.6254 12.9157 11.2487 12.5432 11.2487 12.0824C11.2487 11.6215 11.6179 11.249 12.0787 11.249H12.0862C12.547 11.249 12.9195 11.6215 12.9195 12.0824C12.9195 12.5432 12.547 12.9157 12.0862 12.9157ZM7.08203 7.91569C7.08203 8.37652 7.4587 8.74902 7.91953 8.74902C8.38036 8.74902 8.75286 8.37652 8.75286 7.91569C8.75286 7.45486 8.38036 7.08236 7.91953 7.08236H7.91203C7.4512 7.08236 7.08203 7.45486 7.08203 7.91569Z" fill="#70450A"></path></svg>' + arrBadge[0] + '<span class="wizzy-badge-point-breaker"></span>';
                        let secondText = arrBadge[1].includes("Free") ? '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.88143 1.30601C3.72114 1.30601 3.56366 1.3482 3.42484 1.42835C3.28602 1.5085 3.17075 1.62377 3.0906 1.76259C3.01045 1.90141 2.96826 2.05889 2.96826 2.21918C2.96826 2.37948 3.01045 2.53695 3.0906 2.67577C3.17075 2.81459 3.28602 2.92987 3.42484 3.01002C3.56366 3.09016 3.72114 3.13236 3.88143 3.13236V3.13523H5.46777L4.67452 1.76129L4.67226 1.76259C4.59212 1.62377 4.47684 1.5085 4.33802 1.42835C4.1992 1.3482 4.04173 1.30601 3.88143 1.30601ZM2.53635 2.99577C2.60819 3.1202 2.69663 3.23351 2.79877 3.33281H1.20032C0.905771 3.33281 0.666993 3.57159 0.666993 3.86614V5.99944C0.666993 6.29399 0.905771 6.53276 1.20032 6.53276H1.73368V6.53294V10.7995C1.73368 11.0941 1.97246 11.3329 2.267 11.3329H9.73356C10.0281 11.3329 10.2669 11.0941 10.2669 10.7995V6.53294V6.53276H10.8002C11.0947 6.53276 11.3335 6.29399 11.3335 5.99944V3.86614C11.3335 3.57159 11.0947 3.33281 10.8002 3.33281H9.22355C9.3257 3.23351 9.41413 3.1202 9.48597 2.99577C9.62229 2.75965 9.69406 2.49182 9.69406 2.21918C9.69406 1.94655 9.62229 1.67871 9.48597 1.4426C9.34965 1.20649 9.15359 1.01042 8.91748 0.874101C8.68136 0.737782 8.41353 0.666016 8.14089 0.666016C7.86825 0.666016 7.60042 0.737782 7.36431 0.8741C7.14212 1.00238 6.95539 1.18357 6.82054 1.40125C6.81104 1.4133 6.80228 1.42617 6.79438 1.43985L6.01116 2.79643L5.22794 1.43985C5.22004 1.42617 5.21128 1.41329 5.20178 1.40125C5.06693 1.18357 4.8802 1.00238 4.65801 0.8741C4.4219 0.737782 4.15407 0.666016 3.88143 0.666016C3.60879 0.666016 3.34096 0.737782 3.10485 0.874101C2.86874 1.01042 2.67267 1.20649 2.53635 1.4426C2.40003 1.67871 2.32827 1.94655 2.32827 2.21918C2.32827 2.49182 2.40003 2.75965 2.53635 2.99577ZM7.3478 1.76129L7.35006 1.76259C7.43021 1.62377 7.54548 1.5085 7.6843 1.42835C7.82312 1.3482 7.9806 1.30601 8.14089 1.30601C8.30119 1.30601 8.45866 1.3482 8.59748 1.42835C8.7363 1.5085 8.85158 1.62377 8.93173 1.76259C9.01187 1.90141 9.05407 2.05889 9.05407 2.21918C9.05407 2.37948 9.01187 2.53695 8.93173 2.67577C8.85158 2.81459 8.7363 2.92987 8.59748 3.01002C8.45866 3.09016 8.30119 3.13236 8.14089 3.13236V3.13523H6.55455L7.3478 1.76129ZM1.30698 3.9728V5.89277H5.70187V3.9728H1.30698ZM6.34276 3.9728V5.89277H10.6935V3.9728H6.34276ZM6.34276 6.6396H9.62689V10.6929H6.34276V6.6396ZM5.70187 10.6929H2.37367V6.6396H5.70187V10.6929Z" fill="#70450A"/> </svg>' + arrBadge[1] : '<svg data-v-67befcd3="" data-v-be3184e6="" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-67befcd3="" fill-rule="evenodd" clip-rule="evenodd" d="M10.8922 16.7125C10.4039 17.2034 9.61223 17.2092 9.12056 16.7292L9.11222 16.72C9.1105 16.7182 9.10882 16.7164 9.1072 16.7146C9.10607 16.7134 9.10496 16.7121 9.10389 16.7109L8.50306 16.1117C8.03056 15.6409 7.40306 15.3817 6.73473 15.3809H5.87889C5.18389 15.3809 4.61973 14.8159 4.61973 14.1217V13.2625C4.61973 12.595 4.36056 11.9675 3.88889 11.4942L3.28723 10.8925C2.79473 10.4034 2.79223 9.60419 3.28139 9.11169L3.28723 9.10605C3.29112 9.10234 3.295 9.09864 3.29889 9.09419L3.89056 8.50169C4.36056 8.02836 4.61973 7.40086 4.61973 6.73336V5.87919C4.61973 5.18503 5.18473 4.62003 5.87889 4.61919H6.73639C7.40139 4.61919 8.02889 4.36086 8.50723 3.88836L9.10639 3.28753C9.59556 2.79503 10.3947 2.79253 10.8956 3.28836L11.4972 3.89086C11.9697 4.36003 12.5972 4.61919 13.2647 4.61919H14.1214C14.8164 4.61919 15.3814 5.18419 15.3814 5.87919V6.73503C15.3814 7.40253 15.6397 8.02919 16.1122 8.50503L16.7131 9.10669C16.9522 9.34503 17.0847 9.66086 17.0856 9.99669C17.0864 10.3334 16.9556 10.6509 16.7114 10.8959L16.1114 11.4967C15.6397 11.9692 15.3814 12.5967 15.3814 13.2642V14.1217C15.3814 14.8159 14.8164 15.3809 14.1214 15.3809H13.2631C12.6056 15.3809 11.9606 15.6467 11.4939 16.1125L10.8922 16.7125ZM8.23176 17.6077C8.72093 18.0927 9.36009 18.3343 9.99926 18.3343C10.6443 18.3343 11.2893 18.0877 11.7784 17.5952L12.3768 16.9968C12.6109 16.7643 12.9334 16.631 13.2634 16.631H14.1226C15.5059 16.631 16.6318 15.5052 16.6318 14.1218V13.2643C16.6318 12.9293 16.7618 12.6152 16.9959 12.3793L17.6068 11.7702C18.0793 11.2943 18.3384 10.6635 18.3359 9.99266C18.3334 9.32183 18.0701 8.69266 17.5959 8.22183L16.9976 7.62266C16.7618 7.38516 16.6318 7.06933 16.6318 6.73516V5.87933C16.6318 4.49516 15.5059 3.36933 14.1218 3.36933H13.2651C12.9301 3.36933 12.6151 3.23933 12.3793 3.00516L11.7701 2.39599C10.7876 1.41933 9.19509 1.42433 8.22093 2.40516L7.62509 3.00266C7.38593 3.23849 7.07093 3.36933 6.73676 3.36933H5.87843C4.49509 3.37016 3.37009 4.49599 3.37009 5.87933V6.73349C3.37009 7.06766 3.23926 7.38349 3.00509 7.61933L2.39843 8.22766L2.37593 8.25016C1.42009 9.23349 1.43176 10.8102 2.40509 11.7785L3.00426 12.3768C3.23926 12.6135 3.37009 12.9277 3.37009 13.2627V14.1218C3.37009 15.5052 4.49509 16.631 5.87926 16.631H6.73426C7.06926 16.6318 7.38426 16.7618 7.62009 16.996L8.21176 17.5868C8.21843 17.5943 8.22509 17.601 8.23176 17.6077ZM7.41734 12.5843C7.539 12.7068 7.699 12.7677 7.859 12.7677C8.019 12.7677 8.179 12.7068 8.30067 12.5843L12.5848 8.30102C12.829 8.05685 12.829 7.66102 12.5848 7.41685C12.3407 7.17268 11.9448 7.17268 11.7007 7.41685L7.41734 11.701C7.17317 11.9452 7.17317 12.3402 7.41734 12.5843ZM12.0862 12.9157C11.6254 12.9157 11.2487 12.5432 11.2487 12.0824C11.2487 11.6215 11.6179 11.249 12.0787 11.249H12.0862C12.547 11.249 12.9195 11.6215 12.9195 12.0824C12.9195 12.5432 12.547 12.9157 12.0862 12.9157ZM7.08203 7.91569C7.08203 8.37652 7.4587 8.74902 7.91953 8.74902C8.38036 8.74902 8.75286 8.37652 8.75286 7.91569C8.75286 7.45486 8.38036 7.08236 7.91953 7.08236H7.91203C7.4512 7.08236 7.08203 7.45486 7.08203 7.91569Z" fill="#70450A"></path></svg>' + arrBadge[1];
                        x.offerBadge = firstText + secondText;
                      }else if(arrBadge.length > 0) {
                        temp = arrBadge[0].includes("Free") ? '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.88143 1.30601C3.72114 1.30601 3.56366 1.3482 3.42484 1.42835C3.28602 1.5085 3.17075 1.62377 3.0906 1.76259C3.01045 1.90141 2.96826 2.05889 2.96826 2.21918C2.96826 2.37948 3.01045 2.53695 3.0906 2.67577C3.17075 2.81459 3.28602 2.92987 3.42484 3.01002C3.56366 3.09016 3.72114 3.13236 3.88143 3.13236V3.13523H5.46777L4.67452 1.76129L4.67226 1.76259C4.59212 1.62377 4.47684 1.5085 4.33802 1.42835C4.1992 1.3482 4.04173 1.30601 3.88143 1.30601ZM2.53635 2.99577C2.60819 3.1202 2.69663 3.23351 2.79877 3.33281H1.20032C0.905771 3.33281 0.666993 3.57159 0.666993 3.86614V5.99944C0.666993 6.29399 0.905771 6.53276 1.20032 6.53276H1.73368V6.53294V10.7995C1.73368 11.0941 1.97246 11.3329 2.267 11.3329H9.73356C10.0281 11.3329 10.2669 11.0941 10.2669 10.7995V6.53294V6.53276H10.8002C11.0947 6.53276 11.3335 6.29399 11.3335 5.99944V3.86614C11.3335 3.57159 11.0947 3.33281 10.8002 3.33281H9.22355C9.3257 3.23351 9.41413 3.1202 9.48597 2.99577C9.62229 2.75965 9.69406 2.49182 9.69406 2.21918C9.69406 1.94655 9.62229 1.67871 9.48597 1.4426C9.34965 1.20649 9.15359 1.01042 8.91748 0.874101C8.68136 0.737782 8.41353 0.666016 8.14089 0.666016C7.86825 0.666016 7.60042 0.737782 7.36431 0.8741C7.14212 1.00238 6.95539 1.18357 6.82054 1.40125C6.81104 1.4133 6.80228 1.42617 6.79438 1.43985L6.01116 2.79643L5.22794 1.43985C5.22004 1.42617 5.21128 1.41329 5.20178 1.40125C5.06693 1.18357 4.8802 1.00238 4.65801 0.8741C4.4219 0.737782 4.15407 0.666016 3.88143 0.666016C3.60879 0.666016 3.34096 0.737782 3.10485 0.874101C2.86874 1.01042 2.67267 1.20649 2.53635 1.4426C2.40003 1.67871 2.32827 1.94655 2.32827 2.21918C2.32827 2.49182 2.40003 2.75965 2.53635 2.99577ZM7.3478 1.76129L7.35006 1.76259C7.43021 1.62377 7.54548 1.5085 7.6843 1.42835C7.82312 1.3482 7.9806 1.30601 8.14089 1.30601C8.30119 1.30601 8.45866 1.3482 8.59748 1.42835C8.7363 1.5085 8.85158 1.62377 8.93173 1.76259C9.01187 1.90141 9.05407 2.05889 9.05407 2.21918C9.05407 2.37948 9.01187 2.53695 8.93173 2.67577C8.85158 2.81459 8.7363 2.92987 8.59748 3.01002C8.45866 3.09016 8.30119 3.13236 8.14089 3.13236V3.13523H6.55455L7.3478 1.76129ZM1.30698 3.9728V5.89277H5.70187V3.9728H1.30698ZM6.34276 3.9728V5.89277H10.6935V3.9728H6.34276ZM6.34276 6.6396H9.62689V10.6929H6.34276V6.6396ZM5.70187 10.6929H2.37367V6.6396H5.70187V10.6929Z" fill="#70450A"/> </svg>' + arrBadge[0] : '<svg data-v-67befcd3="" data-v-be3184e6="" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-67befcd3="" fill-rule="evenodd" clip-rule="evenodd" d="M10.8922 16.7125C10.4039 17.2034 9.61223 17.2092 9.12056 16.7292L9.11222 16.72C9.1105 16.7182 9.10882 16.7164 9.1072 16.7146C9.10607 16.7134 9.10496 16.7121 9.10389 16.7109L8.50306 16.1117C8.03056 15.6409 7.40306 15.3817 6.73473 15.3809H5.87889C5.18389 15.3809 4.61973 14.8159 4.61973 14.1217V13.2625C4.61973 12.595 4.36056 11.9675 3.88889 11.4942L3.28723 10.8925C2.79473 10.4034 2.79223 9.60419 3.28139 9.11169L3.28723 9.10605C3.29112 9.10234 3.295 9.09864 3.29889 9.09419L3.89056 8.50169C4.36056 8.02836 4.61973 7.40086 4.61973 6.73336V5.87919C4.61973 5.18503 5.18473 4.62003 5.87889 4.61919H6.73639C7.40139 4.61919 8.02889 4.36086 8.50723 3.88836L9.10639 3.28753C9.59556 2.79503 10.3947 2.79253 10.8956 3.28836L11.4972 3.89086C11.9697 4.36003 12.5972 4.61919 13.2647 4.61919H14.1214C14.8164 4.61919 15.3814 5.18419 15.3814 5.87919V6.73503C15.3814 7.40253 15.6397 8.02919 16.1122 8.50503L16.7131 9.10669C16.9522 9.34503 17.0847 9.66086 17.0856 9.99669C17.0864 10.3334 16.9556 10.6509 16.7114 10.8959L16.1114 11.4967C15.6397 11.9692 15.3814 12.5967 15.3814 13.2642V14.1217C15.3814 14.8159 14.8164 15.3809 14.1214 15.3809H13.2631C12.6056 15.3809 11.9606 15.6467 11.4939 16.1125L10.8922 16.7125ZM8.23176 17.6077C8.72093 18.0927 9.36009 18.3343 9.99926 18.3343C10.6443 18.3343 11.2893 18.0877 11.7784 17.5952L12.3768 16.9968C12.6109 16.7643 12.9334 16.631 13.2634 16.631H14.1226C15.5059 16.631 16.6318 15.5052 16.6318 14.1218V13.2643C16.6318 12.9293 16.7618 12.6152 16.9959 12.3793L17.6068 11.7702C18.0793 11.2943 18.3384 10.6635 18.3359 9.99266C18.3334 9.32183 18.0701 8.69266 17.5959 8.22183L16.9976 7.62266C16.7618 7.38516 16.6318 7.06933 16.6318 6.73516V5.87933C16.6318 4.49516 15.5059 3.36933 14.1218 3.36933H13.2651C12.9301 3.36933 12.6151 3.23933 12.3793 3.00516L11.7701 2.39599C10.7876 1.41933 9.19509 1.42433 8.22093 2.40516L7.62509 3.00266C7.38593 3.23849 7.07093 3.36933 6.73676 3.36933H5.87843C4.49509 3.37016 3.37009 4.49599 3.37009 5.87933V6.73349C3.37009 7.06766 3.23926 7.38349 3.00509 7.61933L2.39843 8.22766L2.37593 8.25016C1.42009 9.23349 1.43176 10.8102 2.40509 11.7785L3.00426 12.3768C3.23926 12.6135 3.37009 12.9277 3.37009 13.2627V14.1218C3.37009 15.5052 4.49509 16.631 5.87926 16.631H6.73426C7.06926 16.6318 7.38426 16.7618 7.62009 16.996L8.21176 17.5868C8.21843 17.5943 8.22509 17.601 8.23176 17.6077ZM7.41734 12.5843C7.539 12.7068 7.699 12.7677 7.859 12.7677C8.019 12.7677 8.179 12.7068 8.30067 12.5843L12.5848 8.30102C12.829 8.05685 12.829 7.66102 12.5848 7.41685C12.3407 7.17268 11.9448 7.17268 11.7007 7.41685L7.41734 11.701C7.17317 11.9452 7.17317 12.3402 7.41734 12.5843ZM12.0862 12.9157C11.6254 12.9157 11.2487 12.5432 11.2487 12.0824C11.2487 11.6215 11.6179 11.249 12.0787 11.249H12.0862C12.547 11.249 12.9195 11.6215 12.9195 12.0824C12.9195 12.5432 12.547 12.9157 12.0862 12.9157ZM7.08203 7.91569C7.08203 8.37652 7.4587 8.74902 7.91953 8.74902C8.38036 8.74902 8.75286 8.37652 8.75286 7.91569C8.75286 7.45486 8.38036 7.08236 7.91953 7.08236H7.91203C7.4512 7.08236 7.08203 7.45486 7.08203 7.91569Z" fill="#70450A"></path></svg>' + arrBadge[0];
                        x.offerBadge = temp;
                      }else {
                        x.offerBadge = x.attributes[i].values[0].value[0];  
                      }
                    }else if(x.attributes[i].id === "product_select_shape_variant") {
                      let selectShapeString = x.attributes[i].values[0].value[0];
                      let parts = selectShapeString.split('||');
  
                      let individualParts = parts.map(part => {
                        const subParts = part.split('+');
                        return {
                          productHandle: subParts[0],
                          image: subParts[1],
                          shape: subParts[2]
                        };
                      });
  
                      let additionalShapeSwatch = individualParts.map(function(item) {
                        return {
                          "swatchValue": item.shape,
                          "productUrl": "https://www.inspereza.com/products/" + item.productHandle,
                          "swatchUrl": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_" + item.shape.toLowerCase() + ".svg",
                        };
                      });
  
                      x.additionalShapeSwatch = [ {"values": additionalShapeSwatch} ];
  
                    }
                  }


                  if(x.additionalShapeSwatch) {
                    for(let i = 0; i < x.attributes.length; i++) {
                      if(x.attributes[i].id === "product_active_shape_product") {
                        let activeShapeValue = x.attributes[i].values[0].value[0];
                        x.additionalShapeSwatch[0].values = x.additionalShapeSwatch[0].values.map(function(item) {
                          if(item.swatchValue === activeShapeValue) {
                            return {
                              ...item,
                              "isSelected": true,
                            };
                          }
                          return {
                            ...item,
                            "isSelected": false,
                          }
                        });
                      }
                    }
                  }
                  
  
                  // if(carats !== null && qualityType !== null && typeDiamond) {
                  //   if(carats > 0.99) {
                  //     if(qualityType === "Lab Grown") {
                  //       x.showIGI = true;
                  //     }else {
                  //       x.showGIA = true;
                  //     }
                  //   }
                  // }  

                  if(carats !== null && qualityType !== null && typeDiamond) {

                    console.log(carats, qualityType, gemstoneCount);
                    
                    if (productType.indexOf("Rings") > -1) {
                      if(carats > 0.99 && gemstoneCount == 1) {
                        if(qualityType === "Lab Grown" || qualityType === "FG-VS" || qualityType.toLowerCase() === "fg-vs") {
                          x.showIGI = true;
                        }else {
                          x.showGIA = true;
                        }
                      }
                    }
                    
                    if (productType.indexOf("Necklaces") > -1) {
                      if(carats > 0.99 && gemstoneCount == 1) {
                        if(qualityType === "Lab Grown" || qualityType === "FG-VS" || qualityType.toLowerCase() === "fg-vs") {
                          x.showIGI = true;
                        }else {
                          x.showGIA = true;
                        }
                      }
                    }
                    
                    if (productType.indexOf("Earrings") > -1) {
                      if(carats > 1.99 && gemstoneCount == 2) {
                        if(qualityType === "Lab Grown"  || qualityType === "FG-VS" || qualityType.toLowerCase() === "fg-vs") {
                          x.showIGI = true;
                        }else {
                          x.showGIA = true;
                        }
                      }
                    }
                  } 

                  if(textualBadge !== null) {
                    x.showTextualBadge = textualBadge;
                  }else if(showAmazing !== null) {
                    x.showAmazing = true;
                  }
                  
                }catch(err) {
                  console.log(err, "<=====err");
                }
                
                
                x.name = x.attributes.filter((attribute)=> attribute.id === "product_product_title_variant").length > 0 ? x.attributes.filter((attribute)=> attribute.id === "product_product_title_variant")[0].values[0].value[0] : ""
                return x;
              });
              
            return productList;
          });
      },
      beforeRenderResults() {
        let self = this;
        self.registerWizzyEvent("BEFORE_RENDER_RESULTS", (data) => {
  
          let facets = data.response.payload.facets;
          
          if(facets) {
            facets.forEach(function(item) {
              if(item.key === "product_Metal" || item.key === "product_active_shape_product" || item.key === "product_Gemstone") {
                item.data.forEach(function(dataItem) {
                  let facetDataItemKey = dataItem.key;
                  let foundImage = (item.key === "product_Metal") ? self.metalSwatcheValues[facetDataItemKey] : (item.key === "product_active_shape_product") ? self.shapeSwatchValues[facetDataItemKey] : self.gemstoneSwatchValues[facetDataItemKey];
                  dataItem.isSwatch = !0;
                  dataItem.isVisualSwatch = !0;
                  dataItem.isURLSwatch = !0;
                  dataItem.swatchValue = foundImage;
                  dataItem.data = {
                      value: item.key,
                      swatch: {
                          type: "visual",
                          value: foundImage
                      }
                  }
                });
              }else if(item.key === "product_delivery_time_product") {
                item.data.sort(function(a, b) {
                  if(Math.floor(Number(a.key)) < Math.floor(Number(b.key))) {
                    return -1;
                  }else if(Math.floor(Number(a.key)) > Math.floor(Number(b.key))) {
                    return 1;
                  }else {
                    return 0;
                  }
                });

                try {
                  item.data.forEach(function(dataItem) {
                    let days = Math.floor(Number(dataItem.key));
                    let resultDate = new Date();
                    resultDate.setDate(resultDate.getDate() + days);
                    dataItem.label = resultDate.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: '2-digit' });
                  });  
                }catch(err) {
                  console.log(err, "<====");
                }
                
              }else if(item.key === "product_quality_custom") {


                // try {
                //   let tempDataPremium = item.data.filter(function(dataItem) {
                //     if(dataItem.key === "Premium") {
                //       return true;
                //     }
                //     return false;
                //   });
  
                //   let tempDataOther = item.data.filter(function(dataItem) {
                //     if(dataItem.key !== "Premium") {
                //       return true;
                //     }
                //     return false;
                //   });
  
                //   let otherKeys = tempDataOther.map(function(tempDataOtherItem) { return tempDataOtherItem.key; });
                //   let otherKeysString = "";
                  
                //   for(let i = 0; i < otherKeys.length; i++) {
                //     otherKeysString += otherKeys[i];
                //     if(i !== otherKeys.length - 1) otherKeysString += ",";
                //   }

  
                //   item.data = [];
                //   if(otherKeysString.length > 0) {
                //     item.data = [
                //       {
                //         "label": "Natural",
                //         "key": otherKeysString
                //       }
                //     ];
                //   }
  
                //   if(tempDataPremium.length > 0) {
                //     item.data.push({
                //       "label": "Lab Grown",
                //       "key": "Premium",
                //     });
                //   }
                // }catch(err) {
                //   console.log(err, "<=== Wizzy error product_quality_custom");
                // }

              }else if(item.key === "product_carat_range_custom") {
                let caratRangeTemp = [];
                for(let i = 0; i < item.data.length; i++) {
                  caratRangeTemp[item.data[i].key] = item.data[i];
                }

                item.data = [];
                for(let i = 0; i < self.caratWeightOrder.length; i++) {
                  if(typeof caratRangeTemp[self.caratWeightOrder[i]] !== 'undefined') {
                    item.data.push(caratRangeTemp[self.caratWeightOrder[i]]);
                  }
                }
              }

              
            });  
          }
          
          
          return data;
        });
      },
      cacheResultRendered(){
        let self = this;
             self.registerWizzyEvent('PRODUCTS_CACHED_RESULTS_RENDERED',()=>{
                    self.enabledSwatch();
          });
        
        
      },

      beforeAutocomplete(){
          let self = this;
          self.registerWizzyEvent('BEFORE_AUTOCOMPLETE_EXECUTED',(payload)=>{
            // payload.getAllVariants = "true";
            // payload.variantsGroup = "";
            // payload.variantsGroupBy = "groupId";
            return payload;
          })
      },
      beforeSearch(){
          let self = this;
          self.registerWizzyEvent('BEFORE_SEARCH_EXECUTED',(payload)=>{
            // payload.getAllVariants = "true";
            // payload.variantsGroup = "";
            // payload.variantsGroupBy = "groupId";
            return payload;
          });
      },

      afterFacetItemGotClicked(){
          let self = this;
          self.registerWizzyEvent('AFTER_FILTER_ITEM_CLICKED',(payload)=>{

            if(window.wizzyConfig.common.isOnCategoryPage) {
              let scrollElement = document.querySelector(".collection_categories");

              if(scrollElement) {
                setTimeout(function() {
                  scrollElement.scrollIntoView({behavior: "smooth" , block: "start", inline: "nearest"});
                }, 500)
              }
            }else {
              let scrollElement = document.querySelector("body");

              if(scrollElement) {
                setTimeout(function() {
                  scrollElement.scrollIntoView({behavior: "smooth" , block: "start", inline: "nearest"});  
                }, 500);
              }
            }
            
            
            if(window.wizzyConfig) {
              if(window.wizzyConfig.pageStore.lastExecutedFilters) {
                let x = JSON.parse(window.wizzyConfig.pageStore.lastExecutedFilters);
                x.variantGroup = "";
                window.wizzyConfig.pageStore.lastExecutedFilters = JSON.stringify(x);
              }
            }
            self.afterFilterItemGotClickedFlag = true;
            return payload;
          });
      },

      wizzySetDefaultSwatch(payload, selectedSwatch) {
        let self = this;
        // if(self.swatchesMap[selectedSwatch] === "product_Gemstone") {
        //   payload.filters.variantsGroup = "Gemstone";
        // }else if(self.swatchesMap[selectedSwatch] === "product_Metal") {
        //   payload.filters.variantsGroup = "Metal";
        // }else if(self.swatchesMap[selectedSwatch] === "product_active_shape_product") {
        //   payload.filters.variantsGroup = "Shape";
        // }
        
        if(payload.filters.attributes) {
          if(payload.filters.attributes[self.swatchesMap[selectedSwatch]]) {
            let temp = payload.filters.attributes[self.swatchesMap[selectedSwatch]].filter(function(item) {
              return item === selectedSwatch;
            });
            if(temp.length === 0) {
              payload.filters.attributes[self.swatchesMap[selectedSwatch]].push(selectedSwatch);
            }
          }else {
            payload.filters.attributes[self.swatchesMap[selectedSwatch]] = [selectedSwatch];
          }
        }else {
          payload.filters.attributes = {};
          payload.filters.attributes[self.swatchesMap[selectedSwatch]] = [selectedSwatch];
        }
        return payload;
      },
      wizzyHandleOtherCollections(payload) {

        // let sort = payload.filters.sort;
        // if(sort.length > 0) {
        //   if(sort[0].field !== "relevance") {
        //     payload.filters.variantsGroup = ""; 
        //     return;
        //   }
        // }
        
        // if((typeof payload.filters.attributes === 'undefined' ||  Object.keys(payload.filters.attributes).length === 0) 
        //     && (typeof payload.filters.sellingPrice === 'undefined' ||  Object.keys(payload.filters.sellingPrice).length === 0)
        // ) {
        //   payload.filters.getAllVariants = "true";
        //   payload.filters.variantsGroup = "Metal"; 
        // }else {
        //   payload.filters.variantsGroup = "";
        // }
      },
      beforeFiltersExecuted() {
        let self = this;
        self.registerWizzyEvent('BEFORE_FILTERS_EXECUTED',(payload)=>{
            
          // payload.filters.variantsGroupBy = "groupId";
          // payload.filters.variantsGroup = "";

          // if(typeof payload.filters.attributes !== 'undefined' && typeof payload.filters.attributes["product_quality_custom"] !== 'undefined') {
          //   let temp = payload.filters.attributes["product_quality_custom"].filter(function(x) {
          //     if(x.includes("Better") || x.includes("Heirloom") || x.includes("Good") || x.includes("Best")) {
          //       return true;
          //     }
          //     return false;
          //   })

          //   if(temp.length > 0) {
          //     let splitArray = temp[0].split(",");

          //     console.log(splitArray, "<===WIZZY payload.filters.attributes");
              
          //     payload.filters.attributes["product_quality_custom"] = payload.filters.attributes["product_quality_custom"].concat(splitArray);
          //     console.log(payload.filters.attributes["product_quality_custom"], "<====WIZZY");
              
          //   }
          // }

          if(window.wizzyConfig.common.isOnCategoryPage) {

            let pathName = window.location.pathname.replace("/collections/", "");

            if(pathName === "gifts-under-500" || pathName === "gifts-under-1000" || pathName === "1-000-2-000" || pathName === "2-000-5-000" || pathName === "above-5-000") {

              let tempFacets = [];

              let facetKeys = Object.keys(payload.filters.facets);

              for(let i = 0; i < facetKeys.length; i++) {
                if(payload.filters.facets[facetKeys[i]].key !== "sellingPrice") {
                  tempFacets.push(payload.filters.facets[facetKeys[i]]); 
                }
              }
              
              payload.filters.facets = tempFacets;
            }
            
            if(pathName === "gifts-under-500") {
              payload.filters.sellingPrice = [
                {
                  "lte": 500,
                }
              ];
            }else if(pathName === "gifts-under-1000") {
              payload.filters.sellingPrice = [
                {
                  "lte": 1000,
                  "gte": 500
                }
              ];
            }else if(pathName === "1-000-2-000") {
              payload.filters.sellingPrice = [
                {
                  "lte": 2000,
                  "gte": 1000
                }
              ];
            }else if(pathName === "2-000-5-000") {
              payload.filters.sellingPrice = [
                {
                  "lte": 5000,
                  "gte": 2000
                }
              ];
            }else if(pathName === "above-5-000") {
              payload.filters.sellingPrice = [
                {
                  "gte": 5000
                }
              ];
            }
          }
          
          if(window.wizzyConfig.common.isOnCategoryPage) { // && window.location.search.length < 10
            let windowCollectionObject = window.collection;
            if(windowCollectionObject) {
              
              let selectedSwatch = window.collection.activeGems;

              if(selectedSwatch === "") {
                selectedSwatch = window.collection.activeCarat;
              }

              if(selectedSwatch === "") {
                selectedSwatch = typeof self.swatchFromCollectionHandle[windowCollectionObject.collectionURL] === 'undefined' ? "" : self.swatchFromCollectionHandle[windowCollectionObject.collectionURL];
              }
              
              if(typeof self.swatchesMap[selectedSwatch] !== 'undefined') {

                if((typeof payload.filters.attributes === 'undefined' ||  Object.keys(payload.filters.attributes).length === 0) 
                    && (typeof payload.filters.sellingPrice === 'undefined' ||  Object.keys(payload.filters.sellingPrice).length === 0)
                  ) { // this means there is no filter applied
                    if(window.wizzyConfig.common.collectionHandle !== "super-savers") {
                        payload = self.wizzySetDefaultSwatch(payload, selectedSwatch);       
                    }
                }else {
                  payload.filters.variantsGroup = "";
                }  
              }else {
                self.wizzyHandleOtherCollections(payload);
              }
            }else {
              self.wizzyHandleOtherCollections(payload);
            }
            
          }
          return payload;
        });
      },
      attachMinPrice(product){
        let foundVariantPrice = product.attributes.filter(x=>x.id=="product_variant_prices");
        let minPrice = 0 ;
        if (foundVariantPrice.length>0) {
          foundVariantPrice=foundVariantPrice[0];
          let values = foundVariantPrice.values;
          minPrice = parseFloat(product.sellingPrice.replaceAll(',',''));
          for(let i in values){
            let value = parseFloat(values[i].value[0]);
            if (minPrice>value) {
              minPrice=value;
            }
          }
  
          
        }
                product.minPrice=minPrice.toLocaleString();
        return product;
      },
      metalSwatcheValues:{
        "14K Rose Gold":"https://inspereza.com/cdn/shop/files/14K_Rose_Gold_Amethyst.jpg",
        "14K Yellow Gold":"https://inspereza.com/cdn/shop/files/14K_Yellow_Gold_Amethyst.jpg",
        "14K White Gold":"https://inspereza.com/cdn/shop/files/14K_White_Gold_Amethyst.jpg",
        "18K Rose Gold":"https://inspereza.com/cdn/shop/files/18K_Rose_Gold_Amethyst.jpg",
        "18K Yellow Gold":"https://inspereza.com/cdn/shop/files/18K_Yellow_Gold_Amethyst.jpg",
        "18K White Gold":"https://inspereza.com/cdn/shop/files/18K_White_Gold_Amethyst.jpg",
        "Silver":"https://inspereza.com/cdn/shop/files/Silver_Amethyst.jpg",
        "Platinum":"https://inspereza.com/cdn/shop/files/Platinum_Amethyst.jpg",
  
        "14K RG/WG":"https://inspereza.com/cdn/shop/files/14K_Rose_Gold_Amethyst.jpg",
        "14K YG/WG":"https://inspereza.com/cdn/shop/files/14K_Yellow_Gold_Amethyst.jpg",
        "14K WG":"https://inspereza.com/cdn/shop/files/14K_White_Gold_Amethyst.jpg",
        "14K WG/RG":"https://inspereza.com/cdn/shop/files/14K_White_Gold_Amethyst.jpg",
        "18K WG/RG":"https://inspereza.com/cdn/shop/files/18K_White_Gold_Amethyst.jpg",
        "18K YG/WG":"https://inspereza.com/cdn/shop/files/18K_Yellow_Gold_Amethyst.jpg",
        "14K RG/WG":"https://inspereza.com/cdn/shop/files/14K_White_Gold_Amethyst.jpg",
        "18K RG/WG":"https://inspereza.com/cdn/shop/files/18K_Rose_Gold_Amethyst.jpg",
  
        "14K Rose Gold/White Gold":"https://inspereza.com/cdn/shop/files/14K_Rose_Gold_Amethyst.jpg",
        "14K Yellow Gold/White Gold":"https://inspereza.com/cdn/shop/files/14K_Yellow_Gold_Amethyst.jpg",
        "14K White Gold/Rose Gold":"https://inspereza.com/cdn/shop/files/14K_White_Gold_Amethyst.jpg",
        "18K White Gold/Rose Gold":"https://inspereza.com/cdn/shop/files/18K_White_Gold_Amethyst.jpg",
        "18K Yellow Gold/White Gold":"https://inspereza.com/cdn/shop/files/18K_Yellow_Gold_Amethyst.jpg",
        "14K Rose Gold/White Gold":"https://inspereza.com/cdn/shop/files/14K_White_Gold_Amethyst.jpg",
        "18K Rose Gold/White Gold":"https://inspereza.com/cdn/shop/files/18K_Rose_Gold_Amethyst.jpg", 
        
      },
      gemstoneSwatchValues:{
        "Diamond":"https://inspereza.com/cdn/shop/files/RoundDiamond.jpg",
        "Sapphire":"https://inspereza.com/cdn/shop/files/RoundSapphire.jpg",
        "Emerald":"https://inspereza.com/cdn/shop/files/RoundEmerald.jpg",
        "Opal":"https://inspereza.com/cdn/shop/files/RoundOpal.jpg",
        "Aquamarine":"https://inspereza.com/cdn/shop/files/RoundAquamarine.jpg",
        "Ruby":"https://inspereza.com/cdn/shop/files/RoundRuby.jpg",
        "Amethyst":"https://inspereza.com/cdn/shop/files/RoundAmethyst.jpg",
        "Garnet":"https://inspereza.com/cdn/shop/files/RoundGarnet.jpg",
        "Morganite":"https://inspereza.com/cdn/shop/files/RoundMorganite.jpg",
        "Swiss Blue Topaz":"https://inspereza.com/cdn/shop/files/RoundSwiss_Blue_Topaz.jpg",
        "Peridot":"https://inspereza.com/cdn/shop/files/RoundPeridot.jpg",
        "Tanzanite":"https://inspereza.com/cdn/shop/files/RoundTanzanite.jpg",
        "Pink Tourmaline":"https://inspereza.com/cdn/shop/files/RoundPink_Tourmaline.jpg",
        "Blue Topaz":"https://inspereza.com/cdn/shop/files/RoundBlue_Topaz.jpg",
        "Citrine":"https://inspereza.com/cdn/shop/files/RoundCitrine.jpg"
      },
      shapeSwatchValues:{
        "Emerald": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_emerald.svg",
        "Cushion": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_cushion.svg",
        "Oval": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_oval.svg",
        "Pear": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_pear.svg",
        "Princess": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_princess.svg",
        "Round": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_round.svg",
        "Marquise": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_marquise.svg",
        "Heart": "https://cdn.shopify.com/s/files/1/0695/3130/4243/files/shape_heart.svg"
      },
      makeGemstoneSwatch(product){
        if (!product.swatches) {
          return product;
        }
        let self = this;
        let foundSwatch = product.swatches.filter(x=>x.key=='product_Gemstone' && x.values.length)
        if (foundSwatch.length) {
          foundSwatch=foundSwatch[0];
  
             foundSwatch.values=foundSwatch.values.map((y)=>{
               let keyTofind=y.value;
               keyTofind=keyTofind.trim();
                let foundImg = self.gemstoneSwatchValues[y.value];
                 if (foundImg) {
                   y.swatchValue=foundImg;
                   y.isVisualSwatch=true;
                 }
               return y;
             });
          
          product.swatchGemstone=foundSwatch;
        }else{
          product.swatchGemstone=false;
        }
        return product;
      },
      makeMetalSwatch(product){
        if (!product.swatches) {
          return product;
        }
        let self = this;
        let foundSwatch = product.swatches.filter(x=>x.key=='product_Metal' && x.values.length)
           if (foundSwatch.length) {
            foundSwatch=foundSwatch[0];
  
               foundSwatch.values=foundSwatch.values.map((y)=>{
               let keyTofind=y.value;
                 keyTofind=keyTofind.trim();
                let foundImg = self.metalSwatcheValues[y.value];
                 if (foundImg) {
                   y.swatchValue=foundImg;
                   y.isVisualSwatch=true;
                 }
               return y;
             });
            
            product.swatchMetal=foundSwatch;
          }else{
            product.swatchMetal=false;
          }
          return product;
        
        return product;
      },
      makeShapeSwatch(product){
        if (!product.swatches) {
          return product;
        }
        let self = this;
        let foundSwatch = product.swatches.filter(x=>x.key=="product_Shape" && x.values.length)
        if (foundSwatch.length) {
          foundSwatch=foundSwatch[0];
  
             foundSwatch.values=foundSwatch.values.map((y)=>{
               let keyTofind=y.value;
               keyTofind=keyTofind.trim();
                let foundImg = self.shapeSwatchValues[y.value];
                 if (foundImg) {
                   y.swatchValue=foundImg;
                   y.isVisualSwatch=true;
                 }
               return y;
             });
          
          product.swatchShape=foundSwatch;
        }else{
          product.swatchShape=false;
        }
        return product;
      },
      makeCaretSwatch(product){
        if (!product.swatches) {
          return product;
        }
        let self = this;
        let foundSwatch = product.swatches.filter(x=>x.key=="product_Carat" && x.values.length)
        if (foundSwatch.length) {
          foundSwatch=foundSwatch[0];
          
          product.swatchCarat=foundSwatch;
        }else{
          product.swatchCarat=false;
        }
        return product;
      },
      setClassForStickyHeader(mutation){
            let cEle= $(mutation.target);
            if (cEle.hasClass('scrolled-past-header')) {
              $('body').addClass('wizzy-sticky-header');
            }else{
              $('body').removeClass('wizzy-sticky-header');
            }
      },
      attachHeaderMutations(){
         let self = this;
        let ele = $(".shopify-section-header-sticky")[0];
        if(ele) {
          let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              self.setClassForStickyHeader(mutation);
            });
          });
          
          observer.observe(ele, {
            attributes: true,
            attributeFilter: ['class']
          });  
        }
        
      },
  
    setClassForAutocomplate(){
          let cEle= $(mutation.target);
            if (cEle.css('display') == "flex") {
              $('body').addClass('wizzy-autocomplate-visible');
            }else{
              $('body').removeClass('wizzy-autocomplate-visible');
            }
    },
    attachAutocomplateMutations(){
        let self = this;
        let ele = $(".wizzy-autocomplete-wrapper")[0];
        let observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            self.setClassForAutocomplate(mutation);
          });
        });
        
        observer.observe(ele, {
          attributes: true,
          attributeFilter: ['attribute']
        });
    },
      attachMutations(){
         this.attachHeaderMutations();
       //  this.attachAutocomplateMutations();
      },
      init(){
        let wizzyCustomInitProcess = [
        'whenScriptLoaded',
        'beforeInit',
        'viewRendered',
        'afterTransform',
        'attachMutations',
        'cacheResultRendered',
        'beforeRenderResults',
          'beforeSearch',
          'beforeFiltersExecuted',
          'afterFacetItemGotClicked',
          'beforeAutocomplete',
        ];
        for(let i in wizzyCustomInitProcess){
          if (typeof this[wizzyCustomInitProcess[i]] == 'function') {
             this[wizzyCustomInitProcess[i]]();
          }
        }
      }
      
  };

  wizzyCustomUtils.init();
  
}


  
